import React, { CSSProperties, FC } from "react";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/modal-delete.svg";
import { ReactComponent as NotifIcon } from "@/assets/icons/modal-notif.svg";
import { ReactComponent as NewsIcon } from "@/assets/icons/modal-news.svg";
import { ReactComponent as StockIcon } from "@/assets/icons/modal-stock-add.svg";
import { ReactComponent as TransferIcon } from "@/assets/icons/modal-stock-transfer.svg";
import { ReactComponent as WarehouseIcon } from "@/assets/icons/modal-warehouse.svg";
import { ReactComponent as CustomStockIcon } from "@/assets/icons/building.svg";

import "./style.scss";

interface ModalPropsTypes {
  style?: CSSProperties;
  withIcon?: boolean;
  withDevider?: boolean;
  type: ModalType;
  title?: string;
  subtitle?: string;
  content?: string | JSX.Element | JSX.Element[] | null;
  footer?: string | JSX.Element | JSX.Element[] | null;
  setIsOpen?: (e: any) => void;
  header?: string | JSX.Element | JSX.Element[] | null; // sorry, biar ga merah aja
  action?: string | JSX.Element | JSX.Element[] | null; // sorry, biar ga merah aja
}

type ModalType =
  | "delete"
  | "notification"
  | "stock"
  | "transfer"
  | "warehouse"
  | "news"
  | "customStock"
  | ""; // sorry, biar ga merah aja

const Modal: FC<ModalPropsTypes> = ({
  setIsOpen,
  style,
  title,
  subtitle,
  content,
  footer,
  type,
  withDevider,
}) => {
  const getIcons = (type: ModalType) => {
    switch (type) {
      case "delete":
        return <DeleteIcon className='icon-modal' />;
      case "notification":
        return <NotifIcon className='icon-modal' />;
      case "news":
        return <NewsIcon className='icon-modal' />;
      case "stock":
        return <StockIcon className='icon-modal' />;
      case "transfer":
        return <TransferIcon className='icon-modal' />;
      case "warehouse":
        return <WarehouseIcon className='icon-modal' />;
      case "customStock":
        return <CustomStockIcon className='icon-modal' />;
      default:
        return "";
    }
  };

  return (
    <>
      <div className='darkBG' />
      <div className='centered'>
        <div style={style} className='modal'>
          {/* --- HEADER SECTION --- */}
          <div className='modalHeader'>
            <div className='headerContent'>
              {getIcons(type)}
              <div className='headerTitle'>
                <span className='title'>{title}</span>
                <span className='subtitle'>{subtitle}</span>
              </div>
              {/* {header} */}
            </div>
            <div className='closeBtn'>
              <CloseIcon onClick={setIsOpen} />
            </div>
          </div>
          {withDevider && <div className='divider' />}
          {/* --- CONTENT SECTION --- */}
          <div className='modalContent'>{content}</div>
          {/* --- FOOTER SECTION --- */}
          {withDevider && <div className='divider' />}
          <div className='modalActions'>
            <div className='actionsContainer'>{footer}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
